import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { get as _get } from "lodash";

const FRAMEWORKS = [
  { id: "disc", labelId: "strategic_analysis.view_report.battlecards.disc", defaultLabel: "DISC Framework" },
  { id: "ocean", labelId: "strategic_analysis.view_report.battlecards.ocean", defaultLabel: "OCEAN Framework" },
];

class BattlecardsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      framework: "disc",
      persona: "D",
    };
  }

  _handleFrameworkChange = (frameworkId) => {
    const personaSets = _get(this.props, `reportData.sections.battlecards.persona_sets.${frameworkId}`, []);
    const defaultPersona = _get(personaSets, "[0].id", "");
    this.setState({ framework: frameworkId, persona: defaultPersona });
  };

  render() {
    const { framework, persona } = this.state;

    const personaSets = _get(this.props, `reportData.sections.battlecards.persona_sets.${framework}`, []);
    const competitors = _get(this.props, "reportData.sections.battlecards.competitors", []);
    const battlecardData = _get(this.props, `reportData.sections.battlecards.data.${framework}.${persona}`, {});

    return (
      <div className="sa-tab-content">
        {/* Section heading */}
        <div className="mb-4">
          <h2 className="sa-section-title">
            <FormattedMessage id="strategic_analysis.view_report.battlecards.title" defaultMessage="Competitor Battlecards" />
          </h2>
          <p className="sa-section-desc">
            <FormattedMessage
              id="strategic_analysis.view_report.battlecards.desc"
              defaultMessage="Sales enablement framework for utilizing the generated leads to displace incumbent competitors based on buyer psychology profiles. Review perceived strengths, execution kill points, and discovery trap questions."
            />
          </p>
        </div>

        {/* Framework tabs */}
        <div className="sa-framework-tabs">
          {FRAMEWORKS.map((fw) => (
            <button
              key={fw.id}
              id={`sa-framework-${fw.id}`}
              type="button"
              className={`sa-framework-btn${framework === fw.id ? " sa-framework-btn--active" : ""}`}
              onClick={() => this._handleFrameworkChange(fw.id)}
            >
              <FormattedMessage id={fw.labelId} defaultMessage={fw.defaultLabel} />
            </button>
          ))}
        </div>

        {/* Persona pills */}
        <div className="sa-persona-pill-bar">
          {personaSets.map((p) => (
            <button
              key={p.id}
              id={`sa-persona-${p.id}`}
              type="button"
              className={`sa-persona-btn${persona === p.id ? " sa-persona-btn--active" : ""}`}
              onClick={() => this.setState({ persona: p.id })}
            >
              {_get(p, "default_label", p.id)}
            </button>
          ))}
        </div>

        {/* Competitor cards */}
        <div className="row g-4">
          {competitors.map((comp) => {
            const entry = _get(battlecardData, comp.id, null);
            if (!entry) { return null; }
            // Derive colour modifier from card_class (e.g. "sa-battlecard--pink" → "pink")
            const cardClass = _get(comp, "card_class", "");
            const colorMod = cardClass.replace("sa-battlecard--", "");
            return (
              <div key={comp.id} className={`col-md-${Math.floor(12 / competitors.length)} d-flex`}>
                <div className={`sa-battlecard ${cardClass} w-100`}>
                  <div className="sa-battlecard__header">
                    <span className={`sa-battlecard__dot ${_get(comp, "dot_class", "")}`} />
                    <FormattedMessage
                      id="strategic_analysis.view_report.battlecards.vs"
                      defaultMessage="Vs. {name}"
                      values={{ name: _get(comp, "name", "") }}
                    />
                  </div>

                  <div className="mb-3">
                    <span className="sa-battlecard__label">
                      <FormattedMessage id="strategic_analysis.view_report.battlecards.perceived_strength" defaultMessage="Perceived Strength" />
                    </span>
                    <p className="sa-battlecard__text">{entry.strength}</p>
                  </div>

                  <div className="sa-battlecard__killpoint mb-3">
                    <span className={`sa-battlecard__label sa-battlecard__killpoint--${colorMod}`}>
                      <FormattedMessage id="strategic_analysis.view_report.battlecards.kill_point" defaultMessage="The Kill Point" />
                    </span>
                    <p className="sa-battlecard__text">{entry.killPoint}</p>
                  </div>

                  <div className="mb-3">
                    <span className="sa-battlecard__label">
                      <FormattedMessage id="strategic_analysis.view_report.battlecards.discovery_trap" defaultMessage="Discovery Trap" />
                    </span>
                    <p className="sa-battlecard__trap">"{entry.trap}"</p>
                  </div>

                  <div className="sa-battlecard__footer">
                    <span className="sa-battlecard__pivot-badge">
                      <FormattedMessage id="strategic_analysis.view_report.battlecards.pivot_to" defaultMessage="Pivot To" />
                    </span>
                    <span className="sa-battlecard__feature">{entry.feature}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default BattlecardsView;
